import React, { Component } from "react";
import { connect } from "react-redux";
import { get_payroll_data, get_payroll_date } from "../../actions/salesAction";
import { export_payroll_data } from "../../actions/exportAction";
import _ from "lodash";
import {
  Button,
  Table,
  Tag,
  Input,
  Select,
  DatePicker,
  message,
  Spin,
  Empty,
} from "antd";
import moment from "moment";
import axiosInstance from "../../actions/AxiosInstance";

const { Option } = Select;

class CashPayments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      marketer: [],
      data: [],
      pagination: {},
      loading: true,
      loadingbtn: false,
      loadingTGbtn: false,
      loadingEPbtn: false,
      retailer: [],
      selectedItems: [],
      selectedfieldname: [],
      selectedfilter: [],
      sort_list: [],
      inventorystatus: [],
      search_text: "",
      datefilter: [],
      startdate: "",
      enddate: "",
      startValue: null,
      endValue: null,
      endOpen: false,
      startdate1: "",
      enddate1: "",
      startValue1: null,
      endValue1: null,
      endOpen1: false,
      office: [],
      fdata: [],
      cashPayments: 2,
      defaultWeek: 1,
      weekType: 1,
      payroll_date: [],
      keyword: "",
    };
  }

  componentWillMount() {
    const urlString = this.props.location.urlpath;
    const urlParams = urlString
      ?.split("?")[1]
      ?.split("&")
      ?.map((v) => v?.split("="));
    const paramsobj = {};
    urlParams?.forEach((element) => {
      paramsobj[element[0]] = element[1];
    });
    this.props
      .get_payroll_date()
      .then((res) => {
        this.setState({ payroll_date: res });
      })
      .catch((err) => console.log(err));
    this.getdesignation({
      results: 10,
      page: 1,
      payroll_type: this.state.cashPayments,
      week_type: this.state.defaultWeek,
    });
    console.log(this.props.user);
  }

  getdesignation(params = {}) {
    this.setState({
      loading: true,
    });
    this.props
      .get_payroll_data(params)
      .then((res) => {
        console.log(res);
        const pagination = { ...this.state.pagination };
        pagination.total = res.total;
        this.setState({
          data: res.data,
          loading: false,
          pagination,
          loadingbtn: false,
          loadingTGbtn: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          loadingbtn: false,
          loadingTGbtn: false,
        });
      });
  }

  handleTableChange = (pagination, filter, sorter) => {
    const pager = { ...this.state.pagination };
    console.log(sorter.order);

    pager.current = pagination.current;
    this.setState({
      pagination: pager,
      sortField: sorter.order === undefined ? "" : sorter.field,
      sortOrder:
        sorter.order === "ascend"
          ? "ASC"
          : sorter.order === undefined
          ? ""
          : "DESC",
    });
    setTimeout(() => {
      this.searchMarketer();
    }, 100);
  };
  // fetch = (params = {}) => {
  //   console.log("params:", params);
  //   this.getdesignation(params);
  // };

  onchangeRole = (selectedItems) => {
    console.log(selectedItems);
    this.setState({ selectedItems });
  };
  onchangefieldname = (selectedfieldname) => {
    this.setState({ selectedfieldname });
    console.log(this.state.selectedfieldname);
  };
  onchangefilter = (selectedfilter) => {
    this.setState({ selectedfilter });
    console.log(this.state.selectedfilter);
  };

  renderOffice() {
    return _.map(this.state.office, (master, index) => {
      return (
        <Option value={master.id} key={index}>
          {master.name}
        </Option>
      );
    });
  }
  clearSearch = () => {
    this.setState({ loading: true });
    this.setState({
      selectedItems: [],
      selectedfieldname: [],
      selectedfilter: [],
      name: "",
      startValue: null,
      endValue: null,
      startValue1: null,
      endValue1: null,
      fdata: [],
      keyword: "",
    });
    this.getdesignation({
      results: 10,
      page: 1,
      payroll_type: this.state.cashPayments,
      week_type: this.state.defaultWeek,
    });
  };

  searchMarketer = (reset) => {
    this.setState({ loading: true, loadingbtn: true });
    var office_id = this.state.selectedItems.key;
    var search_text = this.state.name;
    var sort = this.state.sortField;
    var sort_by = this.state.sortOrder;
    var date_range_start = this.state.startValue;
    var date_range_end = this.state.endValue;
    var term = this.state.keyword;

    this.getdesignation({
      office_id: office_id,
      search_text: search_text,
      date_range_start,
      date_range_end,
      page: reset ? 1 : this.state.pagination?.current ?? 1,
      payroll_type: this.state.cashPayments,
      week_type: this.state.defaultWeek,
      sort,
      sort_by,
      term: term,
    });
  };

  disabledStartDate = (startValue) => {
    const { endValue } = this.state;
    if (!startValue || !endValue) {
      return false;
    }
    return startValue.valueOf() > endValue.valueOf();
  };

  disabledEndDate = (endValue) => {
    const { startValue } = this.state;
    if (!endValue || !startValue) {
      return false;
    }
    return endValue.valueOf() <= startValue.valueOf();
  };
  onChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };
  onStartChange = (value) => {
    this.onChange("startValue", value);
  };

  onEndChange = (value) => {
    this.onChange("endValue", value);
  };
  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  };

  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  };

  disabledStartDate = (startValue) => {
    const weekStart = moment().subtract(31, "days");
    const weekEnd = moment().endOf("day");
    return !(
      weekStart.isSameOrBefore(startValue) && weekEnd.isAfter(startValue)
    );
  };

  disabledEndDate = (endValue) => {
    const weekStart = moment().subtract(31, "days");
    const weekEnd = moment().endOf("day");
    return !weekStart.isSameOrBefore(endValue);
  };
  onChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };
  onStartChange = (value) => {
    this.onChange("startValue", value);
  };

  onEndChange = (value) => {
    this.onChange("endValue", value);
  };
  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  };

  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  };

  //================================================//
  getexportbtn = () => {
    this.setState({
      loading: true,
      loadingEPbtn: true,
    });
    var office_id = this.state.selectedItems.key;
    var search_text = this.state.name;
    var date_range_start = this.state.startValue;
    var date_range_end = this.state.endValue;
    var term = this.state.keyword;
    // this.setState({ loading: true });
    this.props
      .export_payroll_data({
        office_id,
        search_text,
        date_range_start,
        date_range_end,
        payroll_type: this.state.cashPayments,
        week_type: this.state.defaultWeek,
        term: term,
      })
      .then((res) => {
        this.setState({ loading: false, loadingEPbtn: false });
        if (res.original.download === 0) {
          message.success(res.original.message);
        } else {
          window.open(res.data.url, "_blank");
        }
      })
      .catch((err) => {
        this.setState({ loading: false, loadingEPbtn: false });
      });
  };
  fetchUser = (value) => {
    console.log("fetching user", value);
    if (value.length > 1) {
      this.setState({ fdata: [], fetching: true });
      console.log(this);
      axiosInstance
        .get("/api/v1/reference/offices?term=" + value)
        .then((response) => {
          console.log(response.data);
          const fdata = response.data.map((user) => ({
            text: user.name,
            value: user.id,
          }));
          console.log(this);
          this.setState({ fdata, fetching: false });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  getWeekDetails(value) {
    var office_id = this.state.selectedItems.key;
    var search_text = this.state.name;
    this.setState({ loadingTGbtn: true, weekType: value });
    this.getdesignation({
      office_id: office_id,
      search_text: search_text,
      payroll_type: this.state.cashPayments,
      week_type: value,
      page: this.state.pagination?.current ?? 1,
    });
  }
  // ======================================================

  render() {
    const {
      fetching,
      endOpen,
      fdata,
      startValue,
      endValue,
      dateRange,
      weekType,
      loadingTGbtn,
      payroll_date,
      data,
    } = this.state;
    const { user } = this.props;
    const columns = [
      {
        title: "Enrollment ID",
        dataIndex: "enrollment_id",
        key: "enrollment_id",
      },
      {
        title: "Billing State",
        dataIndex: "billing_state",
        key: "billing_state",
      },
      {
        title: "Customer ID",
        dataIndex: "customer_id",
        key: "customer_id",
      },
      {
        title: "Subscriber Status",
        dataIndex: "subscriber_status",
        key: "subscriber_status",
      },
      {
        title: "Invoice Created",
        dataIndex: "invoice_created",
        key: "invoice_created",
      },
      {
        title: "Payment Type",
        dataIndex: "payment_type",
        key: "payment_type",
      },
      {
        title: "Due Date",
        dataIndex: "Due Date",
        key: "Due Date",
      },
      {
        title: "Agent",
        dataIndex: "agent_name",
        key: "agent_name",
      },
      {
        title: "Excess Login ID",
        dataIndex: "excess_login_id",
        key: "excess_login_id",
      },
      {
        title: "Retailer",
        dataIndex: "retailer",
        key: "retailer",
      },
      
      {
        title: "Application Activation Date",
        dataIndex: "application_activation_date",
        key: "application_activation_date",
      },
      {
        title: "ESN Number",
        dataIndex: "esn_number",
        key: "esn_number",
      },
      {
        title: "Lifeline Activation Date",
        dataIndex: "lifeline_activation_date_format",
        key: "lifeline_activation_date_format",
      },
      {
        title: "Disconnection Date",
        dataIndex: "disconnection_date",
        key: "disconnection_date",
      },
      {
        title: "Disconnected By",
        dataIndex: "disconnected_by",
        key: "disconnected_by",
      },
      {
        title: "Reconnection Date",
        dataIndex: "reconnection_date",
        key: "reconnection_date",
      },
      {
        title: "Reconnected By",
        dataIndex: "reconnected_by",
        key: "reconnected_by",
      },
      {
        title: "Suspension Date",
        dataIndex: "suspension_date",
        key: "suspension_date",
      },
      {
        title: "Suspended By",
        dataIndex: "suspended_by",
        key: "suspended_by",
      },
      {
        title: "Invoice Number",
        dataIndex: "invoice_number",
        key: "invoice_number",
      },
      {
        title: "Invoice Type",
        dataIndex: "invoice_type",
        key: "invoice_type",
      },
      {
        title: "USD amount",
        dataIndex: "total_amount",
        key: "total_amount",
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "Transaction Type",
        dataIndex: "transaction_type",
        key: "transaction_type",
      },
      {
        title: "Source",
        dataIndex: "source",
        key: "source",
      },
      {
        title: "Device Cost",
        dataIndex: "device_cost",
        key: "device_cost",
      },

      //===================================
      
      // {
      //   title: "Office",
      //   dataIndex: "office",
      //   key: "office",
      // },
      // {
      //   title: "IBO / Markets",
      //   dataIndex: "ibo",
      //   key: "ibo",
      // },
      
     
      // {
      //   title: "Transaction ID",
      //   dataIndex: "transaction_id",
      //   key: "transaction_id",
      // },
      // {
      //   title: "Created By",
      //   dataIndex: "created_by",
      //   key: "created_by",
      // },
      // {
      //   title: "Stripe",
      //   dataIndex: "stripe",
      //   key: "stripe",
      // },
      
      // {
      //   title: "Total Amount",
      //   dataIndex: "total_amount",
      //   key: "total_amount",
      // },
      // {
      //   title: "Void",
      //   dataIndex: "void",
      //   key: "void",
      // },
      // {
      //   title: "Is Paid",
      //   dataIndex: "is_paid",
      //   key: "is_paid",
      // },
      // {
      //   title: "Is Bill Created",
      //   dataIndex: "is_bill_created",
      //   key: "is_bill_created",
      // },
      // {
      //   title: "Adjust Balance Status",
      //   dataIndex: "adjust_balance_status",
      //   key: "adjust_balance_status",
      // },
      // {
      //   title: "Is Refund",
      //   dataIndex: "is_refund",
      //   key: "is_refund",
      // },
      
      // {
      //   title: "Pre Paid",
      //   dataIndex: "prepaid",
      //   key: "prepaid",
      // },
      
      
      
      
      // {
      //   title: "Invoice Create Type",
      //   dataIndex: "invoice_create_type",
      //   key: "invoice_create_type",
      // },
      // {
      //   title: "Invoice Plan Name",
      //   dataIndex: "invoice_plan_name",
      //   key: "invoice_plan_name",
      // },
      // {
      //   title: "Product Type",
      //   dataIndex: "product_type",
      //   key: "product_type",
      // },
      // {
      //   title: "Total Plan Cost",
      //   dataIndex: "total_plan_cost",
      //   key: "total_plan_cost",
      // },
      // {
      //   title: "Plan Cost",
      //   dataIndex: "plan_cost",
      //   key: "plan_cost",
      // },
    ];

    return (
      <div>
        <div className="container-fluid">
          <div className="row padd20 bg-grey">
            <div className="col-sm-4">
              <h4>
                {" "}
                Cash Payments{" "}
                {this.state.pagination.total &&
                  `(${this.state.pagination.total})`}
              </h4>
            </div>
            <div className="col-sm-8 text-right">
              <Button
                type="primary"
                className="mr5"
                disabled={data?.length === 0}
                loading={this.state.loadingEPbtn}
                onClick={() => this.getexportbtn()}
              >
                <i className="uil uil-export" /> Export Report
              </Button>
            </div>
          </div>
          <div className="row padd20">
            <div className="col-3">
              <label for="exampleFormControlInput1">
                From &#40;Lifeline Activation&#41;
              </label>
              <DatePicker
                value={startValue}
                // disabledDate={this.disabledStartDate}
                format="MM-DD-YYYY"
                placeholder="Select Date"
                onChange={this.onStartChange}
                onOpenChange={this.handleStartOpenChange}
              />
            </div>
            <div className="col-3">
              <label for="exampleFormControlInput1">
                To &#40;Lifeline Activation&#41;
              </label>
              <DatePicker
                value={endValue}
                // disabledDate={this.disabledEndDate}
                format="MM-DD-YYYY"
                placeholder="Select Date"
                onChange={this.onEndChange}
                open={endOpen}
                onOpenChange={this.handleEndOpenChange}
              />
            </div>
            <div className="col-3">
              <label for="exampleFormControlInput1">Select Office</label>
              <Select
                showSearch
                style={{ width: "100%" }}
                labelInValue
                placeholder="Type 2 characters to search..!"
                notFoundContent={fetching ? <Spin size="small" /> : <Empty />}
                filterOption={false}
                onSearch={this.fetchUser}
                defaultActiveFirstOption={false}
                value={this.state.selectedItems}
                onChange={this.onchangeRole}
              >
                {fdata.map((d) => (
                  <Option key={d.value}>{d.text}</Option>
                ))}
              </Select>
            </div>
            <div className="col-3">
              <label for="exampleFormControlInput1">Search By Agent</label>
              <Input
                placeholder="Type Agent Name"
                value={this.state.name}
                // ref={(node) => {
                //   this.searchInput = node;
                // }}
                onChange={(e) =>
                  this.setState({
                    name: e.target.value,
                  })
                }
                style={{ width: "100%", display: "block" }}
              />
            </div>
            <div className="col-3 mt-2">
              <label for="exampleFormControlInput1">Search by Keyword</label>
              <Input
                placeholder="Search by Keyword"
                value={this.state.keyword}
                // ref={(node) => {
                //   this.searchInput = node;
                // }}
                onChange={(e) =>
                  this.setState({
                    keyword: e.target.value,
                  })
                }
                style={{ width: "100%", display: "block" }}
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col mt-2">
              <Button
                type="primary"
                loading={this.state.loadingbtn}
                className="mr5"
                onClick={() => this.searchMarketer("reset")}
              >
                Search
              </Button>
              <Button type="default" onClick={() => this.clearSearch()}>
                Clear
              </Button>
            </div>
          </div>
          <div className="text-left mb-1">
            {payroll_date.this_week_cash_payment && (
              <Button
                type={weekType === 1 ? "danger" : "primary"}
                className="mr5"
                loading={weekType === 1 ? loadingTGbtn : null}
                onClick={() => this.getWeekDetails(1)}
              >
                {payroll_date.this_week_cash_payment}
              </Button>
            )}
            {payroll_date.last_week_cash_payment && (
              <Button
                type={weekType === 2 ? "danger" : "primary"}
                className="mr5"
                loading={weekType === 2 ? loadingTGbtn : null}
                onClick={() => this.getWeekDetails(2)}
              >
                {payroll_date.last_week_cash_payment}
              </Button>
            )}
            {payroll_date.previous_week_cash_payment && (
              <Button
                type={weekType === 3 ? "danger" : "primary"}
                className="mr5"
                loading={weekType === 3 ? loadingTGbtn : null}
                onClick={() => this.getWeekDetails(3)}
              >
                {payroll_date.previous_week_cash_payment}
              </Button>
            )}
          </div>
          <div className="bg-white padd0">
            <Table
              columns={columns}
              dataSource={this.state.data}
              scroll={{ x: true }}
              pagination={this.state.pagination}
              loading={this.state.loading}
              onChange={this.handleTableChange}
              // size="small"
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    data: state.data,
  };
}

export default connect(mapStateToProps, {
  get_payroll_date,
  get_payroll_data,
  export_payroll_data,
})(CashPayments);
